import React from 'react';

function StatCard({ icon: Icon, label, value, trend, colorClass = 'bg-indigo-500', subtext }) {
  return (
    <div className="bg-white rounded-xl shadow-sm p-5 flex items-start gap-4 border border-gray-100">
      <div className={`${colorClass} rounded-lg p-3 flex-shrink-0`}>
        <Icon size={22} className="text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{label}</p>
        <p className="text-2xl font-bold mt-0.5">{value}</p>
        {subtext && <p className="mt-0.5">{subtext}</p>}
        {trend !== undefined && (
          <p className={`mt-1 font-medium ${trend >= 0 ? 'text-green-600' : 'text-red-500'}`}>
            {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}% from last month
          </p>
        )}
      </div>
    </div>
  );
}
export default StatCard;
